export const CONSUMERSCHEMAS_COMPANYID = "57b38b4c0bf00103007d07c1";

export const ALLOWED_WI_ZIPCODES = [
    "53007",
    "53017",
    "53018",
    "53039",
    "53046",
    "53051",
    "53066",
    "53076",
    "53089",
    "53090",
    "53095",
    "53103",
    "53104",
    "53105",
    "53108",
    "53110",
    "53115",
    "53118",
    "53119",
    "53120",
    "53121",
    "53126",
    "53128",
    "53130",
    "53132",
    "53137",
    "53140",
    "53142",
    "53143",
    "53144",
    "53146",
    "53147",
    "53149",
    "53151",
    "53153",
    "53154",
    "53158",
    "53168",
    "53177",
    "53178",
    "53181",
    "53183",
    "53184",
    "53185",
    "53186",
    "53188",
    "53190",
    "53191",
    "53202",
    "53206",
    "53207",
    "53209",
    "53210",
    "53211",
    "53212",
    "53214",
    "53215",
    "53216",
    "53217",
    "53218",
    "53219",
    "53220",
    "53224",
    "53227",
    "53233",
    "53403",
    "53405",
    "53406",
    "53502",
    "53511",
    "53520",
    "53523",
    "53528",
    "53533",
    "53545",
    "53546",
    "53548",
    "53549",
    "53559",
    "53562",
    "53563",
    "53566",
    "53579",
    "53587",
    "53589",
    "53590",
    "53711",
    "53713",
    "53715",
    "53716",
    "53719",
    "53811",
    "53816",
    "53820",
    "54002",
    "54011",
    "54016",
    "54017",
    "54021",
    "54022",
    "54024",
    "54025",
    "54143",
    "54156",
    "54501",
    "54601",
    "54603",
    "54629",
    "54635",
    "54636",
    "54650",
    "54659",
    "54669",
    "54701",
    "54728",
    "54736",
    "54751",
    "54805",
    "54812",
    "54822",
    "54837",
    "54858",
    "54859",
    "54868",
    "54874",
    "54880",
    "54888",
    "54901"
]

export const companiesToDisableCancelOrder = [
    '682742fce289ae49d44a2ca4', // Blew Inc.
    '551b761a857769d7138ebeee', // Howard Zoning Associates
    '58ece9c94eefc40004813011', // Key Zoning Assessments, LLC
    '551b7619857769d7138ebec3', // PZR
    '551b761c857769d7138ebf4a', // NV5
    '691b53dc054e9d4ae3c4e58e', // Disable Company Cancel Order Testing -- STAGING ONLY
]